import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = {
  class: "gfu-bt gfu-bt--caption gfu-hd--uppercase _fw-n _ma-0",
  "data-qa": "statistics-title"
}
const _hoisted_3 = {
  key: 1,
  class: "_tc--accent",
  "data-qa": "statistics-footer"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_admin_router_link = _resolveComponent("admin-router-link")

  return (_openBlock(), _createElementBlock("div", {
    class: "_flexcol _gap-1",
    "data-qa": `statistics-item:${$options.testKey}`
  }, [
    _createElementVNode("h4", _hoisted_2, [
      _createTextVNode(_toDisplayString($props.title) + " ", 1 /* TEXT */),
      ($props.tooltip || _ctx.$slots.content)
        ? (_openBlock(), _createBlock(_component_tooltip, {
            key: 0,
            text: $props.tooltip,
            size: $props.tooltipSize,
            "icon-name": "circle-info",
            position: $props.tooltipPosition,
            theme: $props.tooltipTheme
          }, _createSlots({ _: 2 /* DYNAMIC */ }, [
            (!$props.tooltip && _ctx.$slots.content)
              ? {
                  name: "content",
                  fn: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "content")
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "size", "position", "theme"]))
        : _createCommentVNode("v-if", true)
    ]),
    _createElementVNode("h4", {
      class: _normalizeClass(['gfu-hd gfu-hd--h1', $options.valueHighlight]),
      "data-qa": "statistics-value"
    }, [
      _createTextVNode(_toDisplayString($props.value) + " ", 1 /* TEXT */),
      ($props.iconName)
        ? (_openBlock(), _createBlock(_component_base_icon, {
            key: 0,
            name: $props.iconName,
            class: "_ml-1"
          }, null, 8 /* PROPS */, ["name"]))
        : _createCommentVNode("v-if", true)
    ], 2 /* CLASS */),
    ($props.action)
      ? (_openBlock(), _createBlock(_component_admin_router_link, {
          key: 0,
          to: $props.action.route,
          class: "_tc--accent",
          "data-qa": "statistics-action"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString($props.action.label), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["to"]))
      : _createCommentVNode("v-if", true),
    ($props.footer)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createTextVNode(_toDisplayString($props.footer.label) + " ", 1 /* TEXT */),
          ($props.footer.tooltip)
            ? (_openBlock(), _createBlock(_component_tooltip, {
                key: 0,
                text: $props.footer.tooltip,
                "icon-name": "circle-info",
                theme: $props.tooltipTheme
              }, null, 8 /* PROPS */, ["text", "theme"]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ], 8 /* PROPS */, _hoisted_1))
}